<template>
  <div class="header-tablet-component-anima">
    <div class="nationality-age">
      <img class="country-flag" :src="countryFlag" alt="country-flag" />
      <div class="nationality-age-item valign-text-middle avenirnextltpro-demi-normal-white-10px">
        {{ playerNationality }}
      </div>
      <div class="nationality-age-item valign-text-middle avenirnextltpro-light-white-10px">|</div>
      <div class="nationality-age-item valign-text-middle avenirnextltpro-demi-normal-white-10px">
        {{ player.dob | toAge }} {{ $t('player.years_old') }}
      </div>
    </div>
    <div class="container_data">
      <div class="nationality-data">
        <div class="cont-text-subheader">
          <div class="cont-text-subheader__title">Posición:</div>
          <div class="cont-text-subheader__val">{{ playerPosition }}</div>
        </div>
        <div class="sep-data-line"></div>
        <div class="cont-text-subheader">
          <div class="cont-text-subheader__title">Partidos jugados:</div>
          <div class="cont-text-subheader__val">{{ player.games_played }}</div>
        </div>
        <div class="sep-data-line"></div>
        <div class="cont-text-subheader">
          <div class="cont-text-subheader__title">Minutos jugados:</div>
          <div class="cont-text-subheader__val">{{ player.minutes_played }}</div>
        </div>
        <div class="sep-data-line"></div>
        <div class="cont-text-subheader">
          <div class="cont-text-subheader__title">Torneo:</div>
          <div class="cont-text-subheader__val">
            {{ nameSeasonSelected }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import playerHeaderMixin from '@/utils/mixins/player-header';
export default {
  name: 'NationalityAge',
  props: ['countryFlag', 'player'],
  mixins: [playerHeaderMixin],
  data() {
    return {
      nameSeasonSelected: '',
    };
  },
  mounted() {
    this.setSeasonName();
  },
  watch: {
    player: {
      immediate: true,
      deep: true,
      handler() {
        this.setSeasonName();
      },
    },
    seasons() {
      this.setSeasonName();
    },
    seasonId() {
      this.setSeasonName();
    },
  },
  computed: {
    ...mapGetters('loginGeneral', ['getTournamentsNameSelected', 'getSeasonsNameSelected']),
    ...mapState('filterGeneral', [
      'seasons',
      'hasPlayerNationalTeam',
      'isPlayerNationalTeam',
      'nationalSeasons',
      'hasPlayerClubSeasons',
    ]),
    ...mapGetters('filterGeneral', {
      seasonId: 'getSeasonId',
    }),
  },
  methods: {
    setSeasonName() {
      if (this.player) {
        const selectedSeason = this.seasons.find(season => season.id === this.seasonId);
        if (this.isPlayerNationalTeam) {
          const nationalSeason = this.player.national_seasons[selectedSeason.id];
          this.nameSeasonSelected = nationalSeason ? nationalSeason.name : '';
        } else if (this.player.seasons_v2) {
          this.nameSeasonSelected = this.player.seasons_v2[selectedSeason.id];
        } else if (this.player.seasons && this.player.seasons[selectedSeason.id]) {
          this.nameSeasonSelected = this.player.seasons[selectedSeason.id].alt_name;
        }
      }
    }
  },
};
</script>
<style scoped lang="scss">
.header-tablet-component-anima .container_data {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 14px;
  width: auto;
  margin-top: 6px;
  margin-bottom: -20px;
  position: relative;
}
.header-tablet-component-anima .nationality-data {
  align-items: center;
  display: flex;
  gap: 7.2px;
  position: relative;
  width: auto;
}
.sep-data-line {
  width: 0.3px;
  align-self: stretch;
  flex-grow: 0;
  background-color: rgba(255, 255, 255, 0.51);
}
.cont-text-subheader {
  position: relative;
  min-width: auto;
  font-size: 8px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: -0.14px;
  text-align: left;
  color: #fff;
  display: inline-block;
  height: 18px;
  &__title {
    width: auto;
    font-family: 'Avenir-Regular';
    // background: green;
    text-align: left;
    align-self: stretch;
    padding-right: 5px;
    display: flex;
  }
  &__val {
    width: auto;
    font-family: 'Avenir-Demi';
    // background: rgb(198, 241, 40);
    align-self: stretch;
    text-align: left;
    display: flex;
  }
}
</style>
<style>
.nationality-age,
.nationality-age-1,
.nationality-age-2 {
  align-items: center;
  display: flex;
  gap: 5.79px;
  position: relative;
  width: fit-content;
}

.country-flag,
.country-flag-1,
.country-flag-2 {
  height: 10px;
  max-width: 10px;
  object-fit: cover;
  position: relative;
  border-radius: 10px;
}

.nationality-age-item,
.nationality-age-item-1,
.nationality-age-item-2 {
  letter-spacing: -0.1px;
  line-height: 7.7px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}
</style>
